'use client'

import MainNav from '@/app/components/MainNav'
import PayCalculator from '@/app/components/calculators/PayCalculator'

export default function PayCalculatorPage() {
  return (
    <div className="space-y-8 pb-16">
      <MainNav />
      <div className="mx-auto max-w-6xl px-6">
        <PayCalculator />
      </div>
    </div>
  )
}
